export {};
//# sourceMappingURL=IStorageBuffer.js.map